import {
    ActionReducerMapBuilder,
    PayloadAction,
} from '@reduxjs/toolkit';

import {ITableReportSliceState} from '../table-report-slice-types';
import {performGlobalSearch} from './table-report-search-thunks';
import {ITableReportGlobalSearchCurrentPage, ITableReportLocalSearch} from './table-report-search-types';

export const createTableReportSearchExtraReducer = (builder: ActionReducerMapBuilder<ITableReportSliceState>) => {
    builder.addCase(performGlobalSearch.fulfilled, (state, {payload}) => {
        state.globalSearch.pages = payload;
    });
};

export const createTableReportSearchReducer = <S extends ITableReportSliceState>() => ({
    // local search ↴
    setLocalSearchLine(state: S, {payload}: PayloadAction<{newLine: string}>) {
        state.localSearch.line = payload.newLine;
    },
    setLocalSearchData(state: S, {payload}: PayloadAction<{newData: ITableReportLocalSearch}>) {
        state.localSearch = payload.newData;
    },
    updateLocalSearchData(state: S, {payload}: PayloadAction<{newData: Partial<ITableReportLocalSearch>}>) {
        state.localSearch = {
            ...state.localSearch,
            ...payload.newData,
        };
    },
    // global search ↴
    setGlobalSearchPages(state: S, {payload}: PayloadAction<number[]>) {
        state.globalSearch.pages = payload;
    },
    setGlobalSearchCurrentPage(state: S, {payload}: PayloadAction<ITableReportGlobalSearchCurrentPage>) {
        state.globalSearch.currentPage = payload;
    },
    setGlobalSearchLine(state: S, {payload}: PayloadAction<string>) {
        state.globalSearch.line = payload;
    },
    setGlobalSearchIsLoading(state: S, {payload}: PayloadAction<boolean>) {
        state.globalSearch.isLoading = payload;
    },
    // common ↴
    dropSearch(state: S) {
        state.localSearch = {
            count: null,
            line: '',
            results: [],
            currentSelection: 0,
        };
        state.globalSearch.line = '';
        state.globalSearch.pages = [];
        state.globalSearch.currentPage = {
            index: -1,
            page: -1,
        };
    },
});
